import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, TextField } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ApproveCheckSheet, getAllPM_logs, getPM_planbyId, getPMLogByPlanId } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import DataTable from '../Table';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';


const columns = [
    { id: 'Sr.no', label: 'Sr.no', minWidth: 50 },
    { id: 'check_point', label: 'Checkpoint', minWidth: 120 },
    { id: 'frequency', label: 'Frequency', minWidth: 80 },
    { id: 'status', label: 'Status', minWidth: 80 },
    { id: 'asset_no', label: 'Asset', minWidth: 80 },
    { id: 'asset_description', label: 'Description', minWidth: 150 },
    // { id: 'point_ok', label: 'Point Ok', minWidth: 150 },
    { id: 'observation_values', label: 'Observation', minWidth: 100 },
    { id: 'ng_review_comment', label: 'NG Review Comment', minWidth: 150 },
];

const ChecksheetDetail = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname.split('/');
    const plan_id = pathname[3]
    // const frequency = pathname[4]
    const plan_date = pathname[5]

    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Preventive Maintenance', href: '/preventive-maintenance' },
    ];


    const [loading, setLoading] = useState(true);
    const [ChecksheetDetail, setChecksheetDetail] = useState({});
    const [log, setLog] = useState([]);
    const [approvalComment, setApprovalComment] = useState("");
    const [formData, setFormData] = useState({
        frequency: "",
        startDate: "",
        assetNo: "",
        assetDes: "",
        partNo: ""
    });

    const approvalHandler = async (item) => {
        const isApprove = item === "approve";
        const payload = {
            log_ids: log.map(l => ({
                id: l.id,
                approve: isApprove
            })),
            approval_comment: approvalComment,
            resolve_again: item === "resolve_again"
        };
        console.log("check payload:", payload)
        try {
            const action = dispatch(ApproveCheckSheet(payload));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                toast.success("Success");
                setTimeout(() => {
                    navigate(`/preventive-maintenance/approve-checksheet`);
                }, 2000);
            } else {
                toast.error(res.Message || "Something went wrong!");
            }
        } catch (error) {
            toast.error(error.message || "Failed to create PM log!");
        }
    };

    const getlogs = async () => {
        try {
            const action = dispatch(getPMLogByPlanId({ plan_id: plan_id, plan_date: plan_date }));
            const res = await action.unwrap();
            // Extract logs from response
            let logs = res.result.pm_logs;

            // // Update each log to include asset_no and asset_description
            // logs = logs.map(log => ({
            //     ...log,
            //     asset_no: formData.assetNo,  // Add asset_no from formData
            //     asset_description: formData.assetDes // Add asset_description from formData
            // }));
            // Update each log to include asset_no, asset_description, and observation values
            logs = logs.map(log => {
                // Extract all observation values
                // const observationValues = Object.values(log.observation).map(value => value);
                const observationValues = log.observation ? Object.values(log.observation) : [];

                return {
                    ...log,
                    asset_no: formData.assetNo, // Add asset_no from formData
                    asset_description: formData.assetDes, // Add asset_description from formData
                    observation_values: observationValues, // Set observation_values to the extracted values
                    status: log.point_ok ? "OK" : "NG"
                };
            });

            setLog(logs);

        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };


    const getLogOverview = async () => {
        try {
            const action = dispatch(getAllPM_logs(`?plan_id=${plan_id}&plan_date=${plan_date}`));
            const res = await action.unwrap();
            console.log("check logoverview res:", res)
            setChecksheetDetail(res.result.PM_log_table[0]);
        } catch (error) {
            toast.error(error.message || "No Logs Found!");
        }
    }

    const getPlanbyId = async () => {
        try {
            const action = dispatch(getPM_planbyId(plan_id));
            const res = await action.unwrap();
            if (res.result) {
                // setplan(res.result.pm_plan[0]);
                setFormData({
                    ...formData,
                    frequency: res.result.pm_plan[0].frequency,
                    startDate: res.result.pm_plan[0].start_date,
                    assetNo: res.result.pm_plan[0].assetMaster_details.asset_no,
                    assetDes: res.result.pm_plan[0].assetMaster_details.asset_text,
                    partNo: res.result.pm_plan[0].assetMaster_details.part_no

                });
            };
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
        // console.log("plan fetched:", pmPlan)
    }


    useEffect(() => {
        const fetchData = async () => {
            await getPlanbyId();
            await getLogOverview();
            await getlogs();
            setLoading(false);
        };
        fetchData();
    }, [plan_id]);


    const formatAttendedTimes = (attendedTimes) => {
        return attendedTimes
            .split(';')  // Split into individual time ranges
            .filter(timeRange => timeRange)  // Filter out empty strings
            .map((timeRange, index) => {
                const [start, end] = timeRange.split(' to ');  // Split each time range into start and end
                const formattedStart = convertUTCtoIST(start);  // Use your existing function
                const formattedEnd = convertUTCtoIST(end);  // Use your existing function
                return (
                    <div key={index}>
                        <p>Start: {formattedStart}</p>
                        <p>End: {formattedEnd}</p>
                        <hr />
                    </div>
                );
            });
    };

    // Utility function to convert seconds into hours and minutes
    const formatDuration = (seconds) => {
        const hours = Math.floor(seconds / 3600);  // Get the number of hours
        const minutes = Math.floor((seconds % 3600) / 60);  // Get the remaining minutes
        return `${hours} hr ${minutes} min`;
    };

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }



    return (
        <Layout>
            <Container>
                <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        PM CheckSheet
                    </Typography>
                </Box>
                <Box mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="PM CheckSheet" />
                </Box>
                <Box sx={{
                    margin: '0 auto',
                    maxWidth: '1100px', // Increased max-width
                    padding: '20px',
                    border: '2px solid black',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                }}
                    mb={3} >
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Asset No
                            <h4>{formData.assetNo}</h4>
                        </Grid>
                        <Grid item xs={6} sm={5}>
                            Asset Description
                            <h4>{formData.assetDes}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Status
                            <h4>{ChecksheetDetail.status}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Log Time
                            <h4>{convertUTCtoIST(ChecksheetDetail.last_activity_time)}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Log User
                            <h4>{ChecksheetDetail.log_username}</h4>
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            Done by
                            <h4>{ChecksheetDetail.done_by}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={4}>
                            Attended times
                            <h4>{formatAttendedTimes(ChecksheetDetail.attended_times)}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Duration
                            <h4>{formatDuration(ChecksheetDetail.duration)}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5}>
                            <TextField
                                label="Approval Comment"
                                name="comment"
                                type="text"
                                variant="outlined"
                                fullWidth
                                multiline
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={approvalComment}
                                required
                                onChange={(e) => setApprovalComment(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ marginTop: '10px' }}>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                style={{ backgroundColor: 'green', color: 'white' }}  // Approve button with green background
                                onClick={() => approvalHandler("approve")}
                            >
                                Approve
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                fullWidth
                                style={{ backgroundColor: 'red', color: 'white' }}  // Reject button with red background
                                onClick={() => approvalHandler("reject")}
                            >
                                Reject
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => approvalHandler("resolve_again")}
                            >
                                Resolve Again
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box mt={3} sx={{
                    margin: '0 auto',
                    maxWidth: '1100px', // Increased max-width
                    padding: '20px',
                    border: '2px solid black',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <DataTable data={log} columns={columns} pagination={false} />
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default ChecksheetDetail;
